/**
 *  @class
 *  @function LocalizationForm
 */
if (!customElements.get('localization-form')) {
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.inputs = this.form.querySelectorAll('select[name="locale_code"], select[name="country_code"]');
      this.countrySelect = this.form.querySelector('select[name="country_code"]');
      this.flagElement = this.querySelector("[data-show-flag]");
      this.debouncedOnSubmit = debounce((event) => {
        this.onSubmitHandler(event);
      }, 200);
      this.inputs.forEach((item) => item.addEventListener("change", this.debouncedOnSubmit.bind(this)));

      // Initialize country flag change functionality
      if (this.countrySelect && this.flagElement) {
        this.initCountryFlagChange();
      }
    }

    initCountryFlagChange() {
      const flagTarget = this.countrySelect.dataset.flagTarget;
      if (!flagTarget) return;

      const flagElement = document.getElementById(flagTarget);
      if (!flagElement) return;

      this.countrySelect.addEventListener("change", (event) => {
        const selectedOption = event.target.options[event.target.selectedIndex];
        const flagUrl = selectedOption.dataset.flagUrl;
        const countryName = selectedOption.dataset.countryName;

        if (flagUrl && flagElement) {
          const flagImg = flagElement.querySelector("img");
          if (flagImg) {
            flagImg.src = flagUrl;
            flagImg.alt = countryName;
          }
        }
      });
    }

    onSubmitHandler() {
      if (this.form) this.form.submit();
    }
  }
  customElements.define('localization-form', LocalizationForm);
}